import { render, staticRenderFns } from "./DocumentDetailMenu.vue?vue&type=template&id=0c99b396&scoped=true"
import script from "./DocumentDetailMenu.vue?vue&type=script&lang=js"
export * from "./DocumentDetailMenu.vue?vue&type=script&lang=js"
import style0 from "./DocumentDetailMenu.vue?vue&type=style&index=0&id=0c99b396&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c99b396",
  null
  
)

export default component.exports